<template>
	<div>
		<waiting v-if="loaded == false" />
		<UserList v-if="loaded" :items="items"> </UserList>
	</div>
</template>

<script>
	export default {
		name: 'UserManager',
		props: {},
		data: () => ({
			items: [],
			loaded: false,
			unsubscribeItems: null,
		}),
		mounted: async function() {
			this.loadItems();
		},
		methods: {
			async loadItems() {
				// 화면 접근시 데이터 다시 로딩 :: S
				// this.loaded = false;
				// this.items = await this.$database.loadUsers();
				// this.loaded = true;
				// 화면 접근시 데이터 다시 로딩 :: E

				// 데이터베이스 변동 여부 확인 :: S
				if (this.unsubscribeItems != null) {
					this.unsubscribeItems();
				}
				this.unsubscribeItems = this.$database.onUsers(async () => {
					//this.loaded = false;
					this.items = await this.$database.loadUsers();
					this.loaded = true;
				});
				// 데이터베이스 변동 확인 :: E`
			},
		},
	};
</script>

<style scoped></style>
